<template>
  <div class="toggle-switch flex align-center" :class="{ 'is-disabled': disabled }">
    <div class="toggle-group flex align-center">
      <input
        type="checkbox"
        :id="checkboxId"
        class="toggle"
        :checked="checked"
        :disabled="disabled"
        @change="toggle"
        ref="checkboxInput"
      />
      <label :for="checkboxId" class="toggle-label"></label>
    </div>
    <label :for="checkboxId" class="toggle-text">
      <slot />
    </label>
  </div>
</template>

<script>
import { customCheckbox } from '@/shared/lib/form';

export default {
  mixins: [ customCheckbox ],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checked() {
      return this.value;
    }
  },
  methods: {
    toggle(event) {
      if (this.disabled) return;
      this.$emit('input', event.target.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle-switch {
  input[type="checkbox"] {
    display: none;
  }
}

.toggle-group {
  margin-right: 8px;
}

.toggle-label {
  width: 35px;
  height: 10px;
  background-color: #ccc;
  border-radius: 20px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;

  &::before {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    background-color: white;
    border-radius: 50%;
    top: -3px;
    left: 0;
    transition: transform 0.3s;
    box-shadow: 0px 2px 8px 0px #0000003D;
  }
}

input[type="checkbox"]:checked + .toggle-label {
  background-color: #FB923C;
}

input[type="checkbox"]:checked + .toggle-label::before {
  transform: translateX(20px);
}

.toggle-text {
  cursor: pointer;
  user-select: none;
}

.toggle-switch.is-disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
